import { NextPage } from 'next'
import { useState } from 'react'
import { FaHistory } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { BookList } from 'web_core/assets/book/List'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useESBooks } from 'web_core/hooks/models/useESBooks'
import { DefaultLayout } from '~/components/Layout/Default'
import { ContentNavSelector } from '~/components/Utils/ContentNavSelector'
import { FollowingNavSelector } from '~/components/Utils/FollowingNavSelector'
import { Heading } from '~/components/Utils/Heading'
import { SearchFilter } from '~/components/Utils/SearchFilter'
import { useLayoutProperty } from '~/context/layout_property'
import {
  LayoutStaticProps,
  getDefaultLayoutStaticProps,
} from '~/static_props/layout'
import { bookTimelineBreadcrumb } from '~/utils'

export const getStaticProps = getDefaultLayoutStaticProps

const Page: NextPage<LayoutStaticProps> = ({ categories, popularProfiles }) => {
  const [categoryId, setCategoryId] = useState<string>()
  const { books, loadMore, isReachingEnd, isLoadingMore } = useESBooks({
    locale: 'ja',
    type: 'timeline',
    mode: 'recommend',
    category_id: categoryId,
  })

  const { headerHeight } = useLayoutProperty()

  return (
    <DefaultLayout
      head={{ title: '本のタイムライン', index: false }}
      leftSidebar
      rightSideBar
      categoriesMenu={{ pc: true, sp: true }}
      staticCategories={categories}
      staticPopularProfiles={popularProfiles}
      navLinks={{ pc: true, tablet: true, sp: true, active: 'timeline' }}
    >
      {bookTimelineBreadcrumb.toReactNode()}
      <Heading title="タイムライン" icon={FaHistory} className="mb-0" />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2"
        style={{ top: headerHeight }}
      >
        <ContentNavSelector
          active="books"
          link="/timeline/[contents]"
          className="mb-2 mb-md-4"
        />
        <div className="d-flex justify-content-between gap-4">
          <FollowingNavSelector
            active="recommend"
            link="/timeline/[prefix]books"
            className="flex-shrink-0 fs-7 fs-md-6"
          />
          <SearchFilter
            categoryFilter={{ onSelectId: setCategoryId, id: categoryId }}
            className="fs-7 fs-md-6"
          />
        </div>
      </div>
      <InfiniteScroll
        loadMore={async () => {
          if (isLoadingMore === false && isReachingEnd === false)
            await loadMore()
        }}
        hasMore={isReachingEnd === false}
        loader={<LoadingSpinner />}
      >
        {books && <BookList books={books} />}
      </InfiniteScroll>
    </DefaultLayout>
  )
}

export default Page
